<template>
  <div>
    <!-- Navigation -->
    <NavigationDesktop v-if="false" />
    <NavigationMobile v-else />
    
    <!-- Main Content -->
    <slot />
  </div>
</template>

<script>
import NavigationDesktop from '@/components/layout/NavigationDesktop.vue'
import NavigationMobile from '@/components/layout/NavigationMobile.vue'

export default {
    name: 'Navigation',
    components: {
        NavigationDesktop,
        NavigationMobile
    },
    data: function() {
        return {
            isMobile: false
        }
    },
    mounted() {
        window.addEventListener('resize', this.onResize)
        this.isMobile = window.innerWidth < 800;
    },
    beforeDestroy: function () {
        window.removeEventListener('resize', this.onResize)
    },
    methods: {
        onResize() {
            this.isMobile = window.innerWidth < 800;
        }
    }
}
</script>